module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("CAPÍTULO 1")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("M")]), _vm._v("atías tem oito anos")]), _vm._v(", vai para a terceira série do Ensino Fundamental e seus principais hobbies são:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  comer sanduíches de queijo,")]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  jogar videogame,")]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  jogar futebol no pátio com os colegas")]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  e estudar matemática. ")])]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ah, sim!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Porque acontece que Matías é muito bom em matemática. Sua especialidade é resolver problemas com adição e subtração. Ninguém pode vencê-lo!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hoje é sexta-feira.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E sexta-feira é o melhor dia da semana. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Por que? Bem, por vários motivos: ")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  Em primeiro lugar, porque depois de sexta-feira vem o sábado, e depois de sábado vem o domingo. Portanto, nada de escola durante todo o fim de semana. E isso é muito legal! ")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("-  Além disso, toda sexta-feira ele vai ao cinema com a mãe e o irmão.")])]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("É por isso que agora Matías está pulando na rua. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Salta de pura felicidade. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Vivaaaa! — diz, pulando bem alto. — Vivaaaa!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Seu irmão também está muito feliz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Nós vamos ao cinema hoje! — ele lembra Matías. — Podemos ver aquele filme de dinossauro?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antônio (assim se chama seu irmãozinho) é obcecado por dinossauros. Desde que descobriu que tinha estreado um filme de dinossauro, não para de repetir que quer ir ver. Ele já disse isso um milhão de vezes. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Eu quero ver outro! — protestou Matías. — Há um sobre um cachorro gigante. Esse é mais legal!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antônio pega sua camiseta e começa a sacudí-lo no meio da rua. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Não, não! Eu quero o de dinossauro! ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antônio é seu irmão mais novo. Ele tem seis anos e, quando coloca alguma coisa na cabeça, ninguém tira. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—O de dinossauro! — De repente, começa a gritar. — O de dinossauro! O de dinossauro!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antônio se joga no chão e começa a espernear. As pessoas que passam, olham para ele de relance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Vamos, vamos — diz Matías. — Você ganhou! ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O rosto de Antônio se transforma. Mais uma vez, ele sorri. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Mas na próxima sexta veremos o do cachorro! — diz Matías. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Sim, sim... claro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E eles continuam andando juntos de volta para casa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Como hoje é sexta-feira, quando chegarem em casa, mamãe terá preparado espaguete à bolonhesa, lasanha, pizza ou algo delicioso, delicioso. As sextas-feiras são incríveis. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Matías mora muito perto do colégio, a apenas alguns quarteirões de distância. É por isso que seus pais os deixam voltar sozinhos. Além disso, Matías já tem oito anos, então é muito responsável. Matías tem a missão de esperar o irmão sair da escola, pegar sua mão e voltar para casa juntos.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("É muito importante que Antônio vá o tempo todo segurando sua mão. Antônio não pode andar sozinho porque tem seis anos e é um garoto muito travesso. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Já estamos chegando! — Antônio diz a ele. — Aí está a casa!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Matías aperta sua mão com força. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("—Venha, vamos!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0